import classNames from '@/external/classNames';

type Props = {
  className?: string;
};
const BannerBox: FC<Props> = ({ children, className }) => (
  <div
    className={classNames(
      'relative grid h-24 items-center gap-4 pl-3 before:absolute before:inset-y-0 before:left-0 before:w-px before:bg-beerus 2xl:pl-5',
      className && className,
    )}
  >
    {children}
  </div>
);
export default BannerBox;
